/**
 * Every frontend module this build ships. The one list.
 *
 * **Only `main.tsx` imports this**, and hands it to core through
 * `ModulesProvider`. A core file importing it would import every module, and
 * every module imports core's components. Order is the order of menu entries
 * within a section and of a slot's contributions.
 */
import { boardModule } from './board/module';
import { coffeeModule } from './coffee/module';
import { crmModule } from './crm/module';
import { currencyModule } from './currency/module';
import { messagingModule } from './messaging/module';
import { rocketchatModule } from './rocketchat/module';
import type { FrontendModule } from './types';

export const MODULES: readonly FrontendModule[] = [messagingModule, crmModule, currencyModule, rocketchatModule, boardModule, coffeeModule];
